"use client";

import { useEffect } from "react";
import { useSessionStorage } from "usehooks-ts";
import { useProfile } from "./useProfile";

// Read the `export_url` query param lazily inside the effect (rather than
// via `use-query-params`/`useSearchParams`). Calling those hooks during
// render would force the entire Providers subtree — and therefore every
// App Router page — to bail out to client-side rendering, which strips the
// home page's prerendered HTML of all SEO content.
export const useGuest = () => {
  const { data: profile } = useProfile();

  const [, setExportPageUrl] = useSessionStorage<string | undefined>(
    "export_page_url",
    undefined,
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const queryExportUrl = new URLSearchParams(window.location.search).get(
      "export_url",
    );
    if (queryExportUrl) {
      setExportPageUrl(queryExportUrl);
    }
  }, [profile, setExportPageUrl]);
};
